export default "__VITE_ASSET__C92wY$J___"